import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading, PreloadAllModules, withEnabledBlockingInitialNavigation } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { AuthenticationService } from './features/auth/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(), // block first navigation until APP_INITIALIZER completes
      withComponentInputBinding(), // allow @Input() receive params/query directly
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withPreloading(PreloadAllModules) // lazy loading with preloading
    ),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthenticationService) => () => authService.initializeApp(),
      deps: [AuthenticationService],
      multi: true
    }
  ]
};